import { useTooltip } from "context/TooltipProvider";
import React from "react";
import { editReceivingInvestigationFile } from "services/prosecutorPoliceService";
import { InvestigationFile } from "types";
import { LoadingIcon } from "utils/constant";
import { errorHandler, errorHandlerOnForm } from "utils/helper";

interface Props {
  title?: string;
  message?: string;
  file: InvestigationFile;
  setRefetch: React.Dispatch<React.SetStateAction<boolean>>;
  onCancel: () => void;
  isOpen: boolean;
}

const CloseInvestigationFile: React.FC<Props> = ({
  title = "Close Investigation File",
  message = "Are you sure you want to close this investigation file?",
  onCancel,
  file,
  setRefetch,
  isOpen,
}) => {
  // const { loginData } = useAuth();
  const { showTooltip } = useTooltip();

  const [loading, setLoading] = React.useState(false);
  if (!isOpen) return null;

  const handleClickOutside = (e: any) => {
    if (e.target.classList.contains("fixed")) {
      onCancel();
    }
  };

  // const isClerk = hasRole(loginData?.roles, [Roles.variousClerk]);

  return (
    <div
      style={{ marginTop: "0px" }}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-4"
      onClick={handleClickOutside}
    >
      <div className="bg-white rounded-lg shadow-lg p-6 w-[600px]">
        <h2 className="text-lg font-semibold text-gray-800">{title}</h2>
        {message && <p className="mt-2 text-sm text-gray-600">{message}</p>}

        <div className="mt-4 flex justify-end gap-2">
          <button
            className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            type="submit"
            className={`border border-[#E90101] bg-[#E90101] px-10 py-2 text-white 
                        font-[Poppins] cursor-pointer font-[500] 
                        text-base rounded-md hover:bg-white hover:text-[#E90101]
                        ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
            disabled={loading}
            onClick={() => {
              setLoading(true);
              editReceivingInvestigationFile({
                ...file,
                status: "closed_by_prosecutor",
              })
                .then(() => {
                  setLoading(false);
                  showTooltip("Successfully Closed!", "success");
                  setRefetch(true);
                })
                .catch((error) => {
                  setLoading(false);
                  showTooltip(
                    error?.response?.data?.detail ||
                      errorHandlerOnForm(error) ||
                      errorHandler(error) ||
                      "Something went wrong. Please try again.",
                    "error"
                  );
                });
            }}
          >
            {loading ? (
              <div className="flex items-center justify-center">
                {LoadingIcon}
                Loading...
              </div>
            ) : (
              "Close"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CloseInvestigationFile;
